/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

class OptionalDropdownSelect extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      selectedCompanyArray: [],
      dropdownList: props.dropdownList,
      tempList: props.dropdownList,
      suggestions: this.filterCompanies(searchTerm),
      clearList: props.clearList || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.dropdownList?.length !== prevProps.dropdownList?.length) {
      const { dropdownList, showFirstListElement: flag } = this.props;
      if (!flag || !dropdownList?.length) return;
      this.setInitialSelectedCompanyGroup();
    }
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
    if (this.props.clearList !== prevProps.clearList) {
      this.setState({ selectedCompanyArray: [], searchTerm: '' });
    }
  }

  filterCompanies = value => {
    const inputValue = value.trim().toLowerCase();
    const { dropdownList, filterTag } = this.props;
    if (!dropdownList?.length > 0) return [];
    return dropdownList?.filter(item => {
      return item[filterTag].toLowerCase().includes(inputValue);
    });
  };

  getCompanyValue = item => item[this.props.filterTag];

  renderSuggestion = item => <div>{item[this.props.filterTag]}</div>;

  onChange = (event, { newValue }) => {
    const { MultiSelect } = this.props;
    if (!MultiSelect && newValue === '') {
      this.props.onChange({ name: this.props.nameTag, value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterCompanies(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  setInitialSelectedCompanyGroup = async () => {
    await this.resetInitialSelectedCompanyGroup();
    const { selectedCompanyArray } = this.state;
    const { dropdownList: suggestion, onChange } = this.props;
    const _shallowClone = [...selectedCompanyArray];
    _shallowClone.push(suggestion[0]);
    await this.setState({ selectedCompanyArray: _shallowClone });
    await onChange(_shallowClone);
  };

  resetInitialSelectedCompanyGroup = async () => {
    const { onChange } = this.props;
    const EMPTY_ARRAY = [];
    await this.setState({ selectedCompanyArray: EMPTY_ARRAY });
    await onChange(EMPTY_ARRAY);
  };

  onCompanySelected = (ev, { suggestion, suggestionValue }) => {
    const { selectedCompanyArray } = this.state;
    const { onChange, MultiSelect } = this.props;

    if (MultiSelect) {
      if (selectedCompanyArray.length > 0 && selectedCompanyArray.includes(suggestion)) {
        toast.error('Sorry, Already added in the list');
      } else {
        selectedCompanyArray.push(suggestion);
        this.setState({ selectedCompanyArray });
        onChange(selectedCompanyArray);
      }
    } else {
      const evObj = { name: this.props.nameTag, value: suggestionValue, suggestion };
      this.props.onChange(evObj);
    }
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { dropdownList, userAutocomplete, filterTag } = this.props;
      if (!dropdownList?.length > 0) return [];
      const suggestion = dropdownList?.filter(item => item[filterTag] === e.currentTarget.value);
      this.props.onChange({
        name: this.props.nameTag,
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  removeSelected = ind => {
    const { selectedCompanyArray } = this.state;
    const { onChange } = this.props;
    const duplicateList = selectedCompanyArray;
    duplicateList.splice(ind, 1);
    this.setState({ selectedCompanyArray: duplicateList });
    onChange(duplicateList);
  };

  renderSelectedCompany = () => {
    const { selectedCompanyArray } = this.state;
    return selectedCompanyArray.map((item, ind) => {
      return (
        <div className="multi-input-item m-vertical" key={item.name}>
          <span className="item tm-horizontal">{item.name}</span>
          <FontAwesomeIcon
            icon="window-close"
            size="sm"
            title="Remove Selected Company"
            color="#999"
            mask={['far', 'circle']}
            onClick={() => this.removeSelected(ind)}
          />
        </div>
      );
    });
  };

  render() {
    const { searchTerm, suggestions, selectedCompanyArray } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Item...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: this.props.nameTag,
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        {selectedCompanyArray.length > 0 && (
          <div className="email-list">{this.renderSelectedCompany()}</div>
        )}
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCompanyValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCompanySelected}
        />
      </div>
    );
  }
}

export default OptionalDropdownSelect;
